import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Modal, Grid, TextField } from '@mui/material';
import { FormContainer, RowContainer, BaseLabel, Label, AutoComplete, cores } from '../../../styles/styleUtils'; // Reutilizando seus estilos
import ActionButtons from '../components/ActionButtons';
import ModalLoading from '../../ModalLoading';

// API (assumindo que você tem um arquivo de API)
import { getUsuarios } from '../../api'; // 'createOs' é uma nova função da API

const Style1 = styled(TextField)`
  width: 70%;
  border-radius: 10px;
  box-sizing: border-box;
  background-color: ${cores.branco};
  & .MuiInputBase-root {
    height: 36px;
    padding: 1.5px;
  }
`;

// Componente
const Agendamento = React.forwardRef((props, ref) => {
  const getInititalState = () => ({
    idResponsavelExecucao: props.proposta.idResponsavelExecucao || '', 
    responsavelExecucao: props.proposta.responsavelExecucao || '', 
    dataAgendamento: props.proposta.dataAgendamento || '',
    statusAgenda: props.proposta.statusAgenda || 'Aberta',
  })
  const [formData, setFormData] = useState(getInititalState())
  const [modalLoading, setModalLoading] = useState(false);
  const [disableConfirm, setDisableConfirm] = useState(true);

  // --- Estados para Autocompletes ---
  const [usuarios, setUsuarios] = useState([]);

  const handleDateChange = (newDate) => {
    setFormData((prev) => ({
      ...prev,
      dataAgendamento: newDate,
    }));
  };

  const handleAutoCompleteChange = (idName, name, value) => {
    setModalLoading(true);
    setFormData((prev) => ({
      ...prev,
      [idName]: value?._id,
      [name]: value,
    }));
    setModalLoading(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      const fetchedUsuarios = await getUsuarios();
      setUsuarios(fetchedUsuarios);
    };
    fetchData();
  }, []);

  // --- Lógica de Submissão ---

  const handleSubmit = async () => {
    props.onConfirm(formData);
    props.onClose();
  };

  const handleCancel = () => {
    if (window.confirm('Tem certeza que deseja sair? As alterações não salvas serão perdidas.')) {
      getInititalState()
      props.onClose();
    }
  };

  // --- Validação ---
  useEffect(() => {
    const { idResponsavelExecucao, dataAgendamento, statusAgenda } = formData;
    // Validação básica: precisa de cliente e descrição
    if (idResponsavelExecucao && dataAgendamento && statusAgenda) {
      setDisableConfirm(false);
    } else {
      setDisableConfirm(true);
    }
  }, [formData]);

  const formatToLocalInput = (dateInput) => {
    if (!dateInput) return '';
    const date = new Date(dateInput);

    // Verifica se a data é válida
    if (Number.isNaN(date.getTime())) return '';

    const offset = date.getTimezoneOffset() * 60000; // obtém o deslocamento em milissegundos
    const localDate = new Date(date.getTime() - offset); // ajusta para "falso UTC" que representa o horário local

    // Retorna no formato YYYY-MM-DDTHH:mm, removendo segundos e milissegundos
    return localDate.toISOString().slice(0, 16);
  };

  return (
    <Modal open={props.open} onClose={props.handleClose}>
      <FormContainer>
        <RowContainer>
          <Label htmlFor="cliente">Cliente</Label>
          <Style1 id="cliente" name="cliente" value={props.proposta.cliente?.nome || null} disabled />
        </RowContainer>
        {/* --- Seção Detalhes da OS --- */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <BaseLabel>Código</BaseLabel>
            <Style1
              name="codigo"
              value={props.proposta.codigo}
              sx={{ backgroundColor: cores.branco, borderRadius: 5 }}
              disabled
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <BaseLabel htmlFor="unidade">Unidade</BaseLabel>
            <Style1 id="unidade" value={props.proposta.unidade?.nome || null} disabled />
          </Grid>
          <Grid item xs={12} md={3}>
            <BaseLabel>Cidade</BaseLabel>
            <Style1
              name="cidade"
              value={props.proposta.cliente?.cidade?.nome}
              fullWidth
              placeholder="Ex: Uberlândia"
              sx={{ backgroundColor: cores.branco, borderRadius: 5 }}
              disabled
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <BaseLabel>Telefone</BaseLabel>
            <Style1
              name="telefone"
              value={props.proposta.cliente?.telefone}
              fullWidth
              placeholder="(XX) XXXX-XXXX"
              // TODO: Adicionar máscara de telefone (ex: react-input-mask)
              sx={{ backgroundColor: cores.branco, borderRadius: 5 }}
              disabled
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <BaseLabel>Classificação</BaseLabel>
            <Style1 id="classificacao" value={props.proposta.classificacao.nome || null} disabled />
          </Grid>

          <Grid item xs={12} md={6}>
            {''}
          </Grid>

          {/* --- Distribuidora (Busca API) --- */}
          <Grid item xs={12} md={6}>
            <BaseLabel>Responsável</BaseLabel>
            <AutoComplete
              id="responsavelExecucao"
              value={formData.responsavelExecucao || null}
              onChange={(_, value) => handleAutoCompleteChange('idResponsavelExecucao', 'responsavelExecucao', value)}
              options={usuarios}
              getOptionLabel={(option) => option.nome}
              renderInput={(params) => <TextField {...params} placeholder="Selecione o usuário" />}
            />
          </Grid>

          {/* --- Modelo Inversor (Busca API 'Produtos') --- */}
          <Grid item xs={12} md={6}>
            <BaseLabel>Data</BaseLabel>
            <Style1
              type="datetime-local"
              name="data"
              // Usamos a função auxiliar para garantir que o valor exibido seja o horário local correto
              value={formatToLocalInput(formData.dataAgendamento)}
              onChange={(e) => handleDateChange(new Date(e.target.value))}
              fullWidth
              InputLabelProps={{ shrink: true }}
              sx={{ backgroundColor: cores.branco, borderRadius: 5 }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <BaseLabel>Status Agenda</BaseLabel>
            <AutoComplete
              id="status"
              name="status"
              value={formData.statusAgenda || null}
              onChange={(_, value) => handleAutoCompleteChange(null, 'statusAgenda', value)}
              options={['Aberta', 'Finalizada']}
              renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
            />
          </Grid>
        </Grid>
        {/* --- Botões de Ação --- */}
        <ActionButtons
          onCancel={handleCancel}
          onConfirm={handleSubmit}
          disableConfirm={disableConfirm}
          visualiza={props.visualiza}
        />
        {/* --- Modal de Loading --- */}
        {modalLoading && <ModalLoading open={modalLoading} />}
      </FormContainer>
    </Modal>
  );
});

export default Agendamento;